import moment from "moment";

import { STATUS_CHIP } from "constants";
import { INVERNTORY_QUICK_FILTERS } from "../../constant";

const getFormattedDate = (date) =>
  date
    ? moment(new Date(date)).format("YYYY-MM-DD HH:mm:ss") + ".000000"
    : null;

export const getInventoryPayload = (
  page,
  rowsPerPage,
  filters,
  selectedQuickFilter,
) => {
  const conditions = [];

  if (filters?.orderId) {
    conditions.push({
      type: "SIMPLE",
      field: "orderNumber",
      operator: "eq",
      value: filters.orderId,
    });
  }

  if (filters?.soNumber) {
    conditions.push({
      type: "SIMPLE",
      field: "soNumber",
      operator: "eq",
      value: filters.soNumber,
    });
  }

  if (filters?.plantCode) {
    conditions.push({
      type: "SIMPLE",
      field: "plantCode",
      operator: "eq",
      value: filters.plantCode,
    });
  }

  if (filters?.skuName) {
    conditions.push({
      type: "SIMPLE",
      field: "skuName",
      operator: "like",
      value: `${filters.skuName}%`,
    });
  }

  if (filters?.buyerGstin) {
    conditions.push({
      type: "SIMPLE",
      field: "buyerGstin",
      operator: "eq",
      value: `${filters.buyerGstin}`,
    });
  }

  if (filters?.sellerGstin) {
    conditions.push({
      type: "SIMPLE",
      field: "sellerGstin",
      operator: "eq",
      value: `${filters.sellerGstin}`,
    });
  }

  if (filters?.expectedFGDate) {
    const fromToDates = getDateRangeLocalISO(
      expectedFGDateValue[filters?.expectedFGDate],
    );
    conditions.push({
      type: "SIMPLE",
      field: "expectedFgDate",
      operator: "BETWEEN",
      value: fromToDates,
    });
  }

  if (filters?.soLineItemNumber) {
    conditions.push({
      type: "SIMPLE",
      field: "soLineItemNumber",
      operator: "JSON_ARRAY",
      value: [filters.soLineItemNumber],
    });
  }

  // Add quick filter if selected
  if (selectedQuickFilter && selectedQuickFilter !== "All") {
    conditions.push({
      type: "SIMPLE",
      field: "status",
      operator: "eq",
      value: INVERNTORY_QUICK_FILTERS?.[selectedQuickFilter] || null,
    });
  }

  const payload = {
    offset: page * rowsPerPage,
    limit: rowsPerPage,
    date: getFormattedDate(filters?.uploadDate),
    filterDto: conditions.length
      ? [
          {
            type: "NESTED",
            logic: "AND",
            conditions,
          },
        ]
      : [],
  };

  return payload;
};

export const getStatusData = (status) => {
  const { success, error, warning, attention } = STATUS_CHIP || {};

  const { Unreserved, Released } = INVERNTORY_QUICK_FILTERS;

  switch (status) {
    case Released:
      return { type: success, label: getLabelByValue(status) };
    case Unreserved:
    case INVERNTORY_QUICK_FILTERS["Soft deleted"]:
      return { type: error, label: getLabelByValue(status) };
    case INVERNTORY_QUICK_FILTERS["Awaiting release"]:
      return { type: attention, label: getLabelByValue(status) };
    default:
      return { type: warning, label: status };
  }
};

export const getLabelByValue = (value) => {
  return (
    Object.keys(INVERNTORY_QUICK_FILTERS).find(
      (key) => INVERNTORY_QUICK_FILTERS[key] === value,
    ) || ""
  );
};

const expectedFGDateValue = {
  Today: 1,
  "Next 3 days": 3,
  "Next 7 days": 7,
};

function getDateRangeLocalISO(n) {
  const today = moment().startOf("day");
  const fromDate = today.clone();
  const toDate = today
    .clone()
    .add(n > 1 ? n - 1 : 0, "days")
    .endOf("day");
  return [
    fromDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
    toDate.format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
  ];
}

export const getStatusStyle = (status, theme) => {
  switch (status) {
    case "FAILED":
      return { color: theme.palette.error.dark, label: "Failed" };
    case "PROCESSING":
      return { color: theme.palette.primary.main, label: "Processing" };
    case "PROCESSED":
      return { color: theme.palette.success.dark, label: "Processed" };
    case "UPLOADED":
      return { color: theme.palette.warning.dark, label: "Uploaded" };
    default:
      return {};
  }
};

export const formatDate = (arr) => {
  if (!arr) return "-";
  const [year, month, day, hour, minutes, seconds] = arr;
  return new Date(
    year,
    month - 1,
    day,
    hour,
    minutes,
    seconds,
  ).toLocaleString();
};

export const formatDateToAPI = (date) => {
  if (!date || !moment(date).isValid()) return null;
  return moment(date).format("YYYY-MM-DD");
};
